import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取商品定价规则列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listProductPriceRule(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/productPriceRule.listProductPriceRule',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加商品定价规则
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function saveProductPriceRule(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productPriceRule.saveProductPriceRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新商品定价规则
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function updateProductPriceRule(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productPriceRule.updateProductPriceRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除商品定价规则
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function deleteProductPriceRule(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/productPriceRule.deleteProductPriceRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新商品价格
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function updateProductPrice(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/product.updateProductPrice',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询商品分类
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProductCategory(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/productCategory.queryProductCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}